var map = {
	"./avatars/george_256.png": "1564",
	"./avatars/marple_256.png": "bb09",
	"./avatars/mulder_256.png": "495f",
	"./avatars/nico_256.png": "f3fd",
	"./avatars/olivia_256.png": "d3a4",
	"./avatars/poirot_256.png": "425d",
	"./avatars/scully_256.png": "c6e2",
	"./avatars/sherlock_256.png": "a309",
	"./avatars/walter_256.png": "5e95",
	"./avatars/watson_256.png": "29c0",
	"./base/logo.svg": "f166",
	"./base/maze_background.png": "7b93",
	"./base/maze_background_rotated.png": "b42a",
	"./escape-test/book-closed.jpg": "8892",
	"./escape-test/book-open.png": "009c",
	"./fonts/Braille6-ANSI.ttf": "8fac",
	"./fonts/wizardspeak.ttf": "000f",
	"./puzzles/circuit.png": "ab85",
	"./puzzles/combinationA.svg": "9906",
	"./puzzles/combinationB.svg": "c513",
	"./puzzles/cryptexA.png": "18a2",
	"./puzzles/cryptexB.png": "e861",
	"./puzzles/cryptexM.png": "dd06",
	"./puzzles/laptop.png": "9c84",
	"./sanjuan/beajavi.png": "48d5",
	"./sanjuan/foto_entrada.jpg": "1096",
	"./sanjuan/room00_anuario.png": "c715",
	"./sanjuan/room00_cole.jpg": "96cf5",
	"./sanjuan/room01.jpg": "2460",
	"./sanjuan/room01_bookA.png": "bc5a",
	"./sanjuan/room01_bookB.png": "f2dc",
	"./sanjuan/room02.jpg": "94ae",
	"./sanjuan/room02_blackboard.png": "bf17",
	"./sanjuan/room02_braile.png": "556b",
	"./sanjuan/room03.jpg": "6ecc",
	"./sanjuan/room03_notas.png": "8d19",
	"./sanjuan/room03_pista.png": "4f41",
	"./sanjuan/room03_signos.png": "e390",
	"./sanjuan/room04.jpg": "3153",
	"./sanjuan/room04_perspectiva.png": "30f4",
	"./sanjuan/room05.jpg": "c8b1",
	"./sanjuan/room05_notebook.png": "c28e",
	"./sanjuan/room05_tabla.png": "e906",
	"./sanjuan/room06.jpg": "e018",
	"./sanjuan/room06_monedas.png": "2595",
	"./sanjuan/room06_paises.png": "f78f",
	"./sanjuan/room07.jpg": "eea6",
	"./sanjuan/room07_emoji.png": "6135",
	"./sanjuan/room08.jpg": "fd45",
	"./sanjuan/room08_clipboard.png": "b5dc",
	"./sanjuan/room08_clipboard_mini.png": "95b5",
	"./sanjuan/room09.jpg": "2edd",
	"./sanjuan/room09_notebook.png": "a545",
	"./sanjuan/room09_whois.jpg": "23d0",
	"./sanjuan/room21.jpg": "64c8",
	"./sanjuan/room21_cartabea.png": "5ba7",
	"./sanjuan/room22_carta.png": "3334",
	"./sanjuan/room22_sobre.png": "23ed"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7805";
module.exports = webpackAsyncContext;